import {
  FETCH_COLLECTIONS_REQUEST,
  FETCH_COLLECTIONS_SUCCESS,
  FETCH_COLLECTIONS_FAILURE,
  ADD_COLLECTION_REQUEST,
  ADD_COLLECTION_SUCCESS,
  ADD_COLLECTION_FAILURE,
  UPDATE_COLLECTION_REQUEST,
  UPDATE_COLLECTION_SUCCESS,
  UPDATE_COLLECTION_FAILURE,
  DELETE_COLLECTION_REQUEST,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_FAILURE,
  SET_COLLECTION_EDIT,
  CLEAR_COLLECTION_EDIT,
} from '../../../../types/masters/styles/collection/collectionTypes';
import {
  fetchCollections,
  addCollection,
  updateCollection,
  deleteCollection,
} from '../../../../../api/masters/styles/collection/collectionApi';

export const fetchCollectionsAction = () => async (dispatch) => {
  dispatch({ type: FETCH_COLLECTIONS_REQUEST });
  try {
    const data = await fetchCollections();
    dispatch({ type: FETCH_COLLECTIONS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_COLLECTIONS_FAILURE, payload: error.message });
  }
};

export const addCollectionAction = (collection) => async (dispatch) => {
  dispatch({ type: ADD_COLLECTION_REQUEST });
  try {
    await addCollection(collection);
    dispatch({ type: ADD_COLLECTION_SUCCESS });
    dispatch(fetchCollectionsAction());
  } catch (error) {
    dispatch({ type: ADD_COLLECTION_FAILURE, payload: error.message });
    throw error;
  }
};

export const updateCollectionAction = ({ id, collection }) => async (dispatch) => {
  dispatch({ type: UPDATE_COLLECTION_REQUEST });
  try {
    const data = await updateCollection(id, collection);
    dispatch({ type: UPDATE_COLLECTION_SUCCESS, payload: data });
    dispatch(fetchCollectionsAction());
  } catch (error) {
    dispatch({ type: UPDATE_COLLECTION_FAILURE, payload: error.message });
    throw error;
  }
};

export const deleteCollectionAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_COLLECTION_REQUEST });
  try {
    await deleteCollection(id);
    dispatch({ type: DELETE_COLLECTION_SUCCESS, payload: id });
    dispatch(fetchCollectionsAction());
  } catch (error) {
    dispatch({ type: DELETE_COLLECTION_FAILURE, payload: error.message });
    throw error;
  }
};

export const setCollectionEdit = (collection) => ({
  type: SET_COLLECTION_EDIT,
  payload: collection,
});

export const clearCollectionEdit = () => ({
  type: CLEAR_COLLECTION_EDIT,
}); 